"use client";

import { useTranslations } from "next-intl";

/**
 * The body of an error screen.
 *
 * Shared by the error boundaries so a 403, a 404 and a crash look like the same
 * product rather than three different ones.
 */
export function ErrorContent({
  title,
  message,
  onRetry,
}: {
  title: string;
  message?: string;
  onRetry?: () => void;
}) {
  const t = useTranslations("error");

  return (
    <main className="flex h-dvh items-center justify-center px-6">
      <div className="flex max-w-md flex-col items-center text-center">
        <p className="text-2xl text-red-600">{title}</p>
        {message && <p className="mt-2 text-sm text-red-600">{message}</p>}

        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-6 rounded bg-primary px-4 py-2 text-sm font-medium dynamic-text"
          >
            {t("retry")}
          </button>
        )}
      </div>
    </main>
  );
}
